import React from 'react';

import './no-permissions-table.styles.scss';

const NoPermissionTable = () => {
    // TAD-5644 — `data-testid="no-permission-table"` so tests can assert
    // this fallback rendered (e.g. AdminMainTable's no-privilege paths).
    return (
        <div className={'no-permissions-table'} data-testid="no-permission-table">
            <div style={{ 'height': '40%' }}></div>
            <div className={'no-permissions-lock-icon'}></div>
            <div className={'no-permissions-title'}>Sorry, you don't have permission to use this feature.<br></br>Please contact your Department Administrator for assistance.</div>
            {/* <div className={'no-permissions-title'}>You don't have permission to view this tab</div>
            <div className={'no-permissions-body'}>Please contact your Department Administrator for further assistance</div>                        */}
    </div>
    )
}

export default NoPermissionTable;
